import { createSelector } from "@reduxjs/toolkit";
import { selectSlice } from "../../../../features/choice/model/selectors/selectSlice.js";
import { selectFinancialPrograms } from "./selectFinancialPrograms.js";
const selectSelectedFinancialProgram = createSelector(
  selectSlice,
  selectFinancialPrograms,
  (choice, financialPrograms) => {
    var _a;
    return (_a = financialPrograms == null ? void 0 : financialPrograms.data) == null ? void 0 : _a.find((program) => {
      var _a2;
      return program.uid === ((_a2 = choice.program) == null ? void 0 : _a2.uid);
    });
  }
);
export {
  selectSelectedFinancialProgram
};
